/**
 * Created by itaic on 12/8/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};

    var App = window.App || {};
    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    var lpAgentOutcomes = require('web-agent-assets-js/lpAgentOutcomes');

    var AgentOutcomesViewController = ViewController.extend({
        ControllerName: 'AgentOutcomesViewController',
        applicationType: 'AgentOutcomesViewController',
        SDES: [
            {
                "type": "lead",  //MANDATORY
                "lead": {
                    "topic": "text",  //TOPIC OR NAME OF A SUBMITTED LEAD
                    "value": "number",  //EVALUATED VALUE OF THE LEAD
                    "currency": "text", //CURRENCY OF THE LEAD
                    "leadId": "text"  //LEAD IDENTIFIER OR TICKET ID
                }
            },
            {
                "type": "purchase",  //MANDATORY
                "total": "number",  //TOTAL VALUE OF THE TRANSACTION AFTER DISCOUNT
                "currency": "text", //CURRENCY OF THE TRANSACTION
                "orderId": "text"  //UNIQUE ORDER ID OR RECEIPT ID
            },
            {
                "type": "service",  //MANDATORY
                "service": {
                    "topic": "text",  // SERVICE ACTIVITY TOPIC OR NAME
                    "status": "serviceStatus",  // STATUS ENUM
                    // 0-Complete, 1-In Progress, 2-Approved, 3-cancelled, 4-Not Approved,
                    // 5-Reviewed, 6-Missing Details, 7-Closed, 8-Removed, 9-Assigned,
                    // 10-Waiting for Customer Response, 11-Waiting for Response, 12-Pending, 13-Resolved
                    "category": "text",  // SERVICE CATEGORY NAME
                    "serviceId": "text"  // SERVICE UNIQUE IDENTIFIER OR TICKET ID
                }
            }
        ],

        LPViewMap: {
            SDEFormContainer: ".lpview_outcomes_form_container",
            SDEItemsContainer: ".lpview_outcomes_sde_container",
            SDESubmitButton: ".lpview_outcomes_sde_submit",
            SDEService: ".lp_view_service_status",
            SDEServiceToggle: ".lp_view_service_answer_toggle",
            SDEServiceSelectedAnswer: ".lp_view_selected_answer",
            SDEServiceAnswerContainer: ".lp_view_answer_container"
        },

        StateSuffixes: {
            stateTemplate: "SDENAME_VISITORID",
            error: "_error",
            success: "_success"
        },

        stateClasses: {
            open: "open"
        },

        stateTranslations: {
            "NOFIELDSCOMPLETED": "sdeNoFieldsFilled",
            "SUBMISSIONERROR": "sdeSubmissionError",
            "SUBMISSIONVALIDATIONERROR": "sdeSubmissionValidationError",
            "SUBMISSIONNOTPOSSIBLEERROR": "sdeSubmissionNotPossibleError",
            "SUBMISSIONSUCCESS": "sdeSubmissionSuccess"
        },

        initialize: function (constructorData) {
            this.constructorData = constructorData;
            this.conversationOutComes = constructorData.conversationOutComes;
            this.visitorId = constructorData.visitorId;
            this.sessionId = constructorData.sessionId;
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
            var sessionIdPath = participantPath + '.participantInfo.sessionId';
            this.bindModel({modelPath: sessionIdPath, callback: this.handleSessionId});
            this.SDES = JSON.parse(JSON.stringify(this.SDES));//Make a local copy for the instance
        },
        events: function () {
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
            this.bindModel({modelPath: participantPath + '.participantTag', callback: this.handleParticipantTag});
            this.bindModel({modelPath: "participants.infoServices.visitMonitoring." + this.visitorId + " .state", callback: this.handleMonitoringStopped});//Shark monitoring state listener
        },
        render: function () {
            this.renderSDEs();
        }
    });

    AgentOutcomesViewController.prototype.handleSessionId = function (data) {
        if (data && data.newValue) {
            this.sessionId = data.newValue;
        }
    };

    AgentOutcomesViewController.prototype.handleParticipantTag = function (data) {
        if (data.newValue) {
            if (this.colorTag) {
                this.removeClassMultiElements(this.LPViewMap.SDEFormContainer, this.colorTag);
            }
            this.colorTag = data.newValue;
            this.addColorTag();
        }
    };

    AgentOutcomesViewController.prototype.addColorTag = function () {
        if (this.colorTag && this.view) {
            this.addClassMultiElements(this.LPViewMap.SDEFormContainer, this.colorTag);
        }
    };

    AgentOutcomesViewController.prototype.handleMonitoringStopped = function (data) {
        if (data && data.newValue && data.newValue.error === true) {
            this.disableController();
        }
    };

    AgentOutcomesViewController.prototype.renderSDEs = function () {

        for (var i = 0; i < this.SDES.length; i++) {
            var SDE = this.SDES[i];

            if (this.conversationOutComes[SDE.type]) {//Only render SDEs which were defined as relevant
                var templateOptions = {
                    templateFile: "LP_agent_outcomes_sde_container.html",
                    className: "lpview_outcomes_form_container singleSDE",
                    textInjection: {
                        title: this.translate(SDE.type + "Title"),
                        sdeid: SDE.type + "_" + this.visitorId //This is for error and success place holders
                    }
                };

                var singleSDEView = this.createView(templateOptions);//Render container with button
                var SDEContents = this.getFirstElement(this.LPViewMap.SDEItemsContainer, singleSDEView); //Get container for SDE form
                _renderRows.call(this, SDE, SDEContents, SDE); //Render SDE inputs
                this.bindViewEvent({selector: this.LPViewMap.SDESubmitButton, DOMEvent: "click", callback: _getSubmitClosure(SDE), context: this, inView: singleSDEView});
            }
        }

        function _getSubmitClosure(SDE) {
            return function () {
                this.submitSDE(SDE);
            };
        }

        function _renderRows(obj, view, originalSDE) {
            var selectedProperty;

            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    selectedProperty = obj[key];
                    if (typeof selectedProperty === "object") {
                        _renderRows.call(this, selectedProperty, view, originalSDE);
                    } else if (selectedProperty === "number" || selectedProperty === "text" || selectedProperty === "serviceStatus") {
                        if (this.conversationOutComes[originalSDE.type] && typeof this.conversationOutComes[originalSDE.type].alias[key] === "string") {//We only display items named in the conversationOutComes configuration
                            if (selectedProperty === "serviceStatus") {
                                this.renderServiceStatus(originalSDE, key, view);
                            } else {
                                this.renderInputTextField(originalSDE, key, selectedProperty, view);
                            }
                        }
                        obj[key] = "";//Set it up for population or empty sending
                    }
                }
            }
        }
    };

    AgentOutcomesViewController.prototype.renderServiceStatus = function (SDE, key, view) {
        key = "status";

        var id = "sde_" + key + "_" + Math.floor(Math.random() * 1000000);
        var currentView = this.createView({
            templateFile: "LP_agent_outcomes_select.html",
            textInjection: {
                label: this.getTranslation("service", key),
                id: id
            },
            target: view
        });

        this.bindViewEvent({selector: this.LPViewMap.SDEServiceAnswerContainer, DOMEvent: "click", callback: this.getServiceStatusCallback(SDE), view: currentView});
        this.bindViewEvent({selector: this.LPViewMap.SDEServiceToggle, DOMEvent: "click", callback: this.toggleServiceSDE, view: currentView});
    };

    AgentOutcomesViewController.prototype.getServiceStatusCallback = function (SDE) {

        return function (e) {
            var element = e.target,
                key;

            if (element.hasAttribute("data-value")) {
                SDE.service.status = element.getAttribute("data-value");
                key = element.innerHTML;
                this.getFirstElement(this.LPViewMap.SDEServiceSelectedAnswer).innerHTML = key;
            }
        };
    };

    AgentOutcomesViewController.prototype.toggleServiceSDE = function (e) {
        if (this.serviceOpen) {
            this.removeClass(this.LPViewMap.SDEServiceAnswerContainer, this.stateClasses.open);
            this.serviceOpen = false;
        } else if (!this.disabled && this.isFromChild(e, this.getFirstElement(this.LPViewMap.SDEService), false)) {
            this.addClass(this.LPViewMap.SDEServiceAnswerContainer, this.stateClasses.open);
            this.serviceOpen = true;
        }
    };


    AgentOutcomesViewController.prototype.validateSDE = function (SDE) {

        return validateSDERecursively(SDE);

        function validateSDERecursively(SDE) {
            for (var key in SDE) {
                if (SDE.hasOwnProperty(key) && key !== "type") {
                    if (typeof SDE[key] === "object") {
                        return validateSDERecursively(SDE[key]);
                    } else if (SDE[key] !== "") {
                        return true;
                    }
                }
            }
        }
    };

    /**
     * Removes empty strings from the SDE before submitting. These are either properties which aren't enabled or properties
     * which the agent didn't fill in the UI. Either way - they should not be submitted as empty strings.
     * @param SDE - The SDE to clean before submitting
     */
    AgentOutcomesViewController.prototype.cleanSDEForSubmit = function (SDE) {
        var cleanSDE = lpUtils.cloneObject(SDE);
        removeEmptyStringsFromSDERecursively(cleanSDE);
        return cleanSDE;

        function removeEmptyStringsFromSDERecursively(SDE) {
            var keysToRemove = [];
            for (var key in SDE) {
                if (SDE.hasOwnProperty(key) && key !== "type") {
                    if (typeof SDE[key] === "object") {
                        removeEmptyStringsFromSDERecursively(SDE[key]);
                    } else if (SDE[key] === "") {
                        keysToRemove.push(key);
                    }
                }
            }
            for (var index = 0; index < keysToRemove.length; index++) {
                var keyToRemove = keysToRemove[index];
                SDE[keyToRemove] = null;
                delete SDE[keyToRemove];
            }
        }
    };

    AgentOutcomesViewController.prototype.showError = function (SDEType, msg) {
        var errorSelector = "." + SDEType + "_" + this.visitorId + this.StateSuffixes.error;
        var successSelector = "." + SDEType + "_" + this.visitorId + this.StateSuffixes.success;
        this.getFirstElement(errorSelector).innerHTML = msg;
        this.hide(successSelector);
        this.show(errorSelector);
    };

    AgentOutcomesViewController.prototype.showSuccess = function (SDEType, msg) {
        var successSelector = "." + SDEType + "_" + this.visitorId + this.StateSuffixes.success;
        var errorSelector = "." + SDEType + "_" + this.visitorId + this.StateSuffixes.error;
        this.getFirstElement(successSelector).innerHTML = msg;
        this.hide(errorSelector);
        this.show(successSelector);
    };

    AgentOutcomesViewController.prototype.submitSDE = function (SDE) {

        if (this.validateSDE(SDE)) {
            var cleanSDE = this.cleanSDEForSubmit(SDE);
            lpAgentOutcomes.pushSDE({
                data: cleanSDE,
                success: function (data) {
                    this.submitSuccess(data, cleanSDE);
                },
                error: function (errData) {
                    this.submitError(errData, cleanSDE);
                },
                context: this
            }, this.visitorId, this.sessionId);
        } else {
            this.showError(SDE.type, this.translate(this.stateTranslations.NOFIELDSCOMPLETED));
        }
    };

    AgentOutcomesViewController.prototype.submitSuccess = function (data, SDE) {
        this.showSuccess(SDE.type, this.translate(this.stateTranslations.SUBMISSIONSUCCESS));
    };

    AgentOutcomesViewController.prototype.submitError = function (errData, SDE) {
        var errorCode = errData && errData.body && errData.body.internalCode;
        if (errorCode === 37 || errorCode === 39 || errorCode === 12 || errorCode === 6) {//TODO: Enumerate as properties in definition
            this.disableController(SDE);
        } else if (errorCode === 42) {
            this.showError(SDE.type, this.translate(this.stateTranslations.SUBMISSIONVALIDATIONERROR));
        } else {
            this.showError(SDE.type, this.translate(this.stateTranslations.SUBMISSIONERROR));
        }
    };

    AgentOutcomesViewController.prototype.disableController = function (SDE) {
        this.setAttributeMultiElements(this.LPViewMap.SDESubmitButton, "disabled", "disabled");
        this.setAttributeMultiElements("input", "disabled", "disabled");
        if (SDE) {
            this.showError(SDE.type, this.translate(this.stateTranslations.SUBMISSIONNOTPOSSIBLEERROR));
        }
        this.disabled = true;
    };



    AgentOutcomesViewController.prototype.getTranslation = function (sdeName, key) {
        if (this.conversationOutComes[sdeName].alias && this.conversationOutComes[sdeName].alias[key]) {
            return this.conversationOutComes[sdeName].alias[key];
        } else {
            return this.translate(sdeName + key);
        }
    };

    AgentOutcomesViewController.prototype.renderInputTextField = function (SDE, key, type, view) {
        var id = "sde_" + key + "_" + Math.floor(Math.random() * 1000000);
        var currentView = this.createView({
            templateFile: "LP_agent_outcomes_textInput.html",
            textInjection: {
                label: this.getTranslation(SDE.type, key),
                inputType: "text",
                id: id
            },
            target: view
        });

        this.bindViewEvent({selector: "#" + id, DOMEvent: "change", callback: this.createViewEventCallback(SDE, key), view: currentView});
    };

    AgentOutcomesViewController.prototype.createViewEventCallback = function (SDE, key) {

        return function (e) {
            var currentLocation,
                value = e.target.value;

            if (typeof value === "string") {
                value = value.trim();
            }

            if (SDE.hasOwnProperty(key)) {
                SDE[key] = value;
            } else {
                currentLocation = SDE;
                updateSDEProp(currentLocation, key, value);
            }
        };

        function updateSDEProp(SDEPointer, key, value) {
            for (var prop in SDEPointer) {
                if (SDEPointer.hasOwnProperty(prop) && prop === key) {
                    SDEPointer[key] = value;
                    return;
                }
                else if (typeof SDEPointer[prop] === "object") {
                    updateSDEProp(SDEPointer[prop], key, value);
                }
            }
        }
    };

    return AgentOutcomesViewController;

});
